import Vue from 'vue';
import { Module } from 'vuex';
import { RootState } from '@/types/store';

export interface TrainingPlanState {
    trainingPlanMap: {
        [planId: string]: Activity.TrainingPlan;
    };
}

const m: Module<TrainingPlanState, RootState> = {
    namespaced: true,

    state: () => ({
        trainingPlanMap: {},
    }),

    mutations: {
        /** 设置训练计划 */
        setTrainingPlanMap(state, { activityId, weekNo, data }) {
            // 实际周数从0开始计数
            Vue.set(state.trainingPlanMap, `${activityId}_${weekNo}`, data);
        },
    },
    actions: {
        /**
         * 获取训练计划
         * @param activityId 活动id
         * @param weekNo 第几周
         */
        async getTrainingPlan({ state, commit }, { activityId, weekNo }) {
            const response = await Vue.axios.get('api/v1/medal/training_plan_list', {
                params: {
                    activity_id: activityId,
                    week_no: weekNo + 1,
                },
            });
            const rdata = response.data;
            if (rdata.status === 0) {
                commit('setTrainingPlanMap', {
                    activityId,
                    weekNo,
                    data: rdata.data,
                });
            }
            return rdata;
        },
        /**
         * 选择训练计划
         * @param activityId 活动id
         * @param trainLevel 选择的训练计划等级
         */
        async chooseTrainLevel(context, { activityId, trainLevel }: { activityId: string, trainLevel: string }) {
            const response = await Vue.axios.post('api/v1/medal/choose_train_level', {
                activity_id: activityId,
                train_level: trainLevel,
            });
            const rdata = response.data;
            return rdata;
        },
    },
};

export default m;
